export default "__VITE_ASSET__c56fb3a6__$_?component__"